import React, { useState, useEffect } from "react";
import Card from "components/card";
import { Globe } from "lucide-react";

const ClockCard = ({
    country,
    city,
    timezone,
    variant,
}) => {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
        setNow(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const timeFormatter = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZoneName: "short",
    });

    const dateFormatter = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        weekday: "short",
        month: "short",
        day: "2-digit",
    });

    const formattedTime = timeFormatter.format(now);
    const parts = formattedTime.split(" ");
    const time = parts.slice(0, -1).join(" ");
    const tzAbbr = parts[parts.length - 1];

    return (
        <Card className={`clock ${variant} `}>
            <div className="pb-6 p-3 tracking-normal">
                <div className="flex items-center gap-2 mb-2">
                    <div className="p-1.5 rounded-full iconBg">
                        <Globe className="w-4 h-4 iconText" />
                    </div>
                    <div>
                        <p className="text-[11px]  muted-text">{country}</p>
                        <p className="text-[9px] muted-text">
                            {`${tzAbbr} (${city})`}
                        </p>
                    </div>
                </div>
                <p className="text-[24px] font-bold timeText mb-0.5">
                    {time}
                </p>
                <p className="text-[10px] muted-text">
                    {dateFormatter.format(now)}
                </p>
            </div>
        </Card>
    )
};
export default ClockCard;